%fila {
	// display: flex;
	// align-items: flex-start;
	// justify-content: space-between;
	// gap: 20px;
	padding: 12px 10px;
	border-bottom: 1px solid #d8e0e8;
}
.container {
	font-family: 'Ringside', sans-serif;
	font-size: 16px;
	line-height: 18px;
	header {
		@extend %fila;
		background: #d8e0e8;
		font-weight: 700;
	}
	.fila {
		@extend %fila;
	}
	.tipologia {
		@extend %fila;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		> *:last-child {
			text-align: right;
		}
	}
	.serveis {
		@extend %fila;
		border-bottom: none;
		display: flex;
		flex-direction: column;
		gap: 5px;
		ul {
			display: flex;
			flex-flow: row wrap;
			gap: 5px;
			li {
				background-color: #f4f6f8;
				padding: 2px 6px;
				border-radius: 4px;
			}
		}
	}
}
